// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eMibO","scrollbars":"styles_scrollbars__AJkyL","title":"styles_title__t2sVz","slideInSearchBar":"styles_slideInSearchBar__azJwm"};